/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Studentcreationmailoverride3Inputs */

const de__field_studentcreationmailoverride3 = /** @type {(inputs: _Field_Studentcreationmailoverride3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lehrer Email für Anmeldungen`)
};

/**

* @param {_Field_Studentcreationmailoverride3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_studentcreationmailoverride3 = /** @type {((inputs?: _Field_Studentcreationmailoverride3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Studentcreationmailoverride3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_studentcreationmailoverride3(inputs)
});
export { _field_studentcreationmailoverride3 as "_field_studentCreationMailOverride" }